import { Alert, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useProfileQuery } from "../../queries";
import { usePermissions, useProfile } from "../../contexts";
import { Claims, UserTypes } from "../../models";

export function PinRequiredModal() {
    const location = useLocation();
    const { getMyUserProfile } = useProfileQuery();
    const { currentUser } = useProfile();
    const { hasAnyRole, hasPermission } = usePermissions();
    const myUserProfile = getMyUserProfile.data;
    const hasPin = myUserProfile?.hasPin;
    const isViewingProfile = location.pathname.includes("/profile");
    const hasExternalRole = hasAnyRole([UserTypes.SurgeryScheduler, UserTypes.Surgeon]);
    const canViewInternal = hasPermission(Claims.ViewInternal);
    const isExternal = hasExternalRole || !canViewInternal;

    return (
        <Modal show={!!currentUser && !hasPin && !isViewingProfile && !!myUserProfile && !isExternal} centered>
            <Modal.Header>PIN Required</Modal.Header>
            <Modal.Body>
                <Alert variant="warning">You have not set your PIN.</Alert>
                <Link to="/profile" className="btn btn-primary w-100">
                    Set your PIN now
                </Link>
            </Modal.Body>
        </Modal>
    );
}
